import { render, staticRenderFns } from "./AllContactsBlock.vue?vue&type=template&id=791636e7&scoped=true&"
import script from "./AllContactsBlock.vue?vue&type=script&lang=ts&"
export * from "./AllContactsBlock.vue?vue&type=script&lang=ts&"
import style0 from "./AllContactsBlock.vue?vue&type=style&index=0&id=791636e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791636e7",
  null
  
)

export default component.exports